// src/private/Callout.jsx
import React from "react";
import { useT } from "../i18n/langContext";
import "./Callout.css";

// Small non-blocking onboarding tooltip. The caller positions it (via className or style)
// and may pass onDismiss to show a × button.
export default function Callout({ text, className = "", style, onDismiss, onClick }) {
  const t = useT();
  return (
    <div
      className={`callout ${className}${onClick ? ' callout--clickable' : ''}`}
      style={style}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
    >
      <span className="callout__text">{text}</span>
      {onDismiss && (
        <button
          className="callout__x"
          onClick={(e) => {
            e.stopPropagation();
            onDismiss();
          }}
          aria-label={t('canvas.callout.dismissAria')}
        >
          ✕
        </button>
      )}
    </div>
  );
}
